let datafile = null;

export const initDatafile = () => {
  datafile = window.INITIAL_STATE.optimizelyDatafile;
};

export const getDatafile = () => datafile;
